import GraphQLJSON from 'graphql-type-json';

const typeResolvers = {};

const resolvers = {
  JSON: GraphQLJSON,
};

const contacts = ({ companyId, globalOutletId }) => {
  return [
    {
      entityId: 1,
      name: 'test distributor',
      phoneNumber: '1234567890',
      entity: 'DISTRIBUTOR',
    },
    {
      entityId: 2,
      name: 'test salesman',
      phoneNumber: '1234567890',
      entity: 'USER',
      role: 'DISTRIBUTOR SALESMAN',
    },
    {
      entityId: 3,
      name: 'test ccd',
      phoneNumber: '1234567890',
      entity: 'USER',
    },
  ];
};

const mocks = {
  Query: {
    contacts: (_, { companyId, globalOutletId }) =>
      contacts({ companyId, globalOutletId }),
  },
};

export { resolvers, typeResolvers, mocks };
